import { wealthProApi } from '../../redux/api';

const reportStatusEndpointOptions = {
    addTagTypes: ["reportStatusesList"],
};

const reportStatusEndpoints = wealthProApi.enhanceEndpoints(reportStatusEndpointOptions).injectEndpoints({
    endpoints: (builder) => ({
        fetchAvailableReportStatusesList: builder.query({
            query: ({ masterAccountId, reportId }) => `/api/reports/master-accounts/${masterAccountId}/reports/${reportId}/status/list`,
            providesTags: (result, error, { reportId }) => {
                return [{ type: 'reportStatusesList', id: reportId }];
            }
        }),
        fetchReportStatuses: builder.query({
            query: () => `/api/reports/report-statuses`
        }),
        fetchReportStatusesList: builder.query({
            query: ({ masterAccountId, reportId }) => masterAccountId && reportId
                ? `/api/reports/master-accounts/${masterAccountId}/reports/${reportId}/status/list`
                : `/api/reports/report-statuses/list`
        })
    })
});

export const {
    useFetchAvailableReportStatusesListQuery,
    useFetchReportStatusesQuery,
    useFetchReportStatusesListQuery,
    useLazyFetchReportStatusesListQuery
} = reportStatusEndpoints;